import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(dateStr) {
  if (!dateStr) return '';
  return dayjs(dateStr)
    .tz('America/Argentina/Buenos_Aires')
    .locale('es')
    .format('D MMMM YYYY');
}

export const inRange = (start, end, now = new Date()) => {
  const t = now.getTime();
  const s = start ? new Date(start).getTime() : -Infinity;
  const e = end ? new Date(end).getTime() :  Infinity;
  return t >= s && t <= e;
};

export const rangePosition = (start, end, now = new Date()) => {
  const t = now.getTime();
  const s = start ? new Date(start).getTime() : NaN;
  const e = end ? new Date(end).getTime() : NaN;
  if (Number.isNaN(s) && Number.isNaN(e)) return null;
  if (!Number.isNaN(s) && t < s) return -1;
  if (!Number.isNaN(e) && t > e) return 1;
  return 0;
};